<template>
  <div class="nav-wrapper">
    <div class="experience-container">
    <div class="form-section">
      <div class="business-form">
        <BackButton @back="$emit('back')" />
        <h1 class="main-title">{{ $t('businessProgress.title') }}</h1>

        <div class="experience-options">
          <label class="experience-option" :class="{ 'selected': businessProgress === 'launching' }">
            <input type="radio" v-model="businessProgress" value="launching" class="radio-input">
            <span class="radio-custom"></span>
            <span class="option-text">{{ $t('businessProgress.options.launching') }}</span>
          </label>

          <label class="experience-option" :class="{ 'selected': businessProgress === 'making_money' }">
            <input type="radio" v-model="businessProgress" value="making_money" class="radio-input">
            <span class="radio-custom"></span>
            <span class="option-text">{{ $t('businessProgress.options.making_money') }}</span>
          </label>

          <label class="experience-option" :class="{ 'selected': businessProgress === 'planning' }">
            <input type="radio" v-model="businessProgress" value="planning" class="radio-input">
            <span class="radio-custom"></span>
            <span class="option-text">{{ $t('businessProgress.options.planning') }}</span>
          </label>
        </div>

        <button class="next-button" @click="handleNext">{{ $t('businessProgress.next') }}</button>
        <button class="skip-button" @click="$emit('skip')">{{ $t('businessProgress.skip') }}</button>
      </div>
    </div>
    <div class="image-section">
      <img src="@/assets/slider6.1.png" alt="Productive workspace with laptop" class="main-image">
    </div>
  </div>
  </div>
</template>

<script>
import BackButton from './BackButton.vue'

export default {
  name: 'BusinessProgress',
  components: {
    BackButton
  },
  data() {
    return {
      businessProgress: 'launching'
    }
  },
  methods: {
    handleNext() {
      this.$emit('next', {
        businessProgress: this.businessProgress
      });
    }
  }
}
</script>

<style scoped>
@import '@/styles/CustomerBusiness.css';

</style> 